var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "pagination"
  }, [_c('h6', [_vm._v("Pagination")]), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "size": "md",
      "total-rows": 100,
      "per-page": 10
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }), _vm._v(" "), _c('br')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46618175","hasScoped":true}!./src/views/components/pagination/pagination.component.html
// module id = 807
// module chunks = 1